import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

// import FeatherIcon from 'feather-icons-react/build/FeatherIcon'
import { avatar18, bulidingicon, profilebg } from '../../imagepath'
import Header from '../../header/Header'
import Sidebar from '../sidebar/SideBar'
import Footer from '../../footer/Footer'
import { CiMenuKebab } from 'react-icons/ci'
import { authority, profileDetails } from '../../../utlis/data'
import { Button, Carousel } from 'antd'
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
const avatar01 = "data:image/jpeg;base64,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"

const PartyInfo = () => {

    const [data, setData] = useState(authority)
    const [partyInfo, setPartInfo] = useState(profileDetails)
    const location = useLocation();

    const contentStyle = {
        height: '300px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
        width: '100%'
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 4,
            slidesToSlide: 4 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 768 },
            items: 3,
            slidesToSlide: 3 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 767, min: 464 },
            items: 2,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

    const CustomCarouselControls = ({ currentSlide, totalSlides, onPrev, onNext }) => {
        return (
            <div>
                <button onClick={onPrev} disabled={currentSlide === 0}>Previous</button>
                <button onClick={onNext} disabled={currentSlide === totalSlides - 1}>Next</button>
            </div>
        );
    };
    const arrayLength = data.partyInfo.length
    const secondaryColor="#278D27"
    const textColor = '#FFFFFF'
    return (
        <>
            <div className="main-wrapper">
                {/* Header */}
                <Header sprAdmin={true} />

                {/* Sidebar */}
                <Sidebar secondaryColor={secondaryColor} textColor={textColor} />

                {/* Page Wrapper */}
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="page-sub-header">
                                        <h3 className="page-title">Party Details</h3>
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/teacherslist">Dashboard</Link>
                                            </li>
                                            <li className="breadcrumb-item active">Party Info</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="about-info">
                                            <h4 className='font-bold'>
                                                Party Information
                                                <span>
                                                    <Link to="#">
                                                        <i className="feather-more-vertical">
                                                            {/* <CiMenuKebab /> */}
                                                            <Button style={{backgroundColor:"#F97D09",color:"white"}}>Edit</Button>
                                                        </i>
                                                    </Link>
                                                </span>
                                            </h4>
                                        </div>

                                        <div className="">
                                            <div className='grid grid-cols-2 gap-3 justify-center'>
                                                {data.partyInfo.map((info, index) => (
                                                    <div key={index}
                                                        className={`p-4 text-center flex flex-col justify-center items-center ${index === arrayLength-1 && (index % 2 === 0) ? 'col-span-2' : ''}`}>
                                                        <p > {info.icon} </p>
                                                        <h1>{info.name}</h1>
                                                        <p>Description</p>
                                                    </div>
                                                ))}

                                            </div>

                                            <div className='mt-5'>
                                                <h1 className='font-bold'>Development Initiative</h1>
                                                <div className='flex mt-3 gap-5 overflow-auto scrollbar-hide'>

                                                    {partyInfo?.devInitiative?.map((info) => (
                                                        <div>
                                                            <div className="blog-image w-60 relative rounded-lg">
                                                                <Link to={"/detail-view"} state={{details:info,from: location,}} >
                                                                    <img
                                                                        className="img-fluid w-40"
                                                                        src={info.image}
                                                                        alt="Post Image"
                                                                    />
                                                                </Link>
                                                                
                                                                <div className='absolute bottom-2 left-3 text-white'>
                                                                    <p>{info.headline}</p>
                                                                    <p className='truncate  w-40'>{info.description}</p>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    ))}
                                                </div>
                                            </div>

                                            <div className='mt-5'>
                                                <h1 className='font-bold'>Previous Works</h1>
                                                <div className='flex mt-3 gap-5 overflow-auto scrollbar-hide'>

                                                    {partyInfo?.devInitiative?.map((info) => (
                                                        <div>
                                                            <div className="blog-image w-60 relative rounded-lg">
                                                                <Link to="/blogdetails">
                                                                    <img
                                                                        className="img-fluid w-40"
                                                                        src={info.image}
                                                                        alt="Post Image"
                                                                    />
                                                                </Link>
                                                                
                                                                <div className='absolute bottom-2 left-3 text-white'>
                                                                    <p>{info.headline}</p>
                                                                  <p className='truncate w-40'>{info.description}</p>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    ))}
                                                </div>
                                            </div>


                                            <div className='mt-5'>
                                                <h1 className='font-bold'>Gallery</h1>
                                                <div
                                                    id="carouselExampleControls"
                                                    className="carousel slide mt-3"
                                                    data-bs-ride="carousel"
                                                >
                                                    <div className="carousel-inner " role="listbox">
                                                        <div className="carousel-item active">
                                                            <img
                                                                className="d-block img-fluid w-full "
                                                                src={avatar01}
                                                                alt="First slide"
                                                            />
                                                        </div>
                                                        {partyInfo.galleryImage.map((image, index) => (

                                                            <div className={`carousel-item  ${index === '0' ? 'active' : ''}`}>
                                                                <img
                                                                    className="d-block img-fluid w-full h-full"
                                                                    src={image}
                                                                    alt="Second slide"
                                                                />
                                                            </div>
                                                        ))}

                                                    </div>
                                                    <Link
                                                        className="carousel-control-prev"
                                                        to="#carouselExampleControls"
                                                        role="button"
                                                        data-bs-slide="prev"
                                                    >
                                                        <span
                                                            className="carousel-control-prev-icon"
                                                            aria-hidden="true"
                                                        />
                                                        <span className="visually-hidden">Previous</span>
                                                    </Link>
                                                    <Link
                                                        className="carousel-control-next"
                                                        to="#carouselExampleControls"
                                                        role="button"
                                                        data-bs-slide="next"
                                                    >
                                                        <span
                                                            className="carousel-control-next-icon"
                                                            aria-hidden="true"
                                                        />
                                                        <span className="visually-hidden">Next</span>
                                                    </Link>
                                                </div>
                                            </div>

                                            {/* <div className='mt-5'> */}

                                            {/* <Carousel autoplay 
                                                 prevArrow={<CustomCarouselControls />}
                                                 nextArrow={<CustomCarouselControls />} >
                                                    <div>
                                                        <img src={avatar01} style={contentStyle} alt="" srcset="" />
                                                    </div>
                                                    <div>
                                                        <h3 style={contentStyle}>2</h3>
                                                    </div>
                                                    <div>
                                                        <h3 style={contentStyle}>3</h3>
                                                    </div>
                                                    <div>
                                                        <h3 style={contentStyle}>4</h3>
                                                    </div>
                                                </Carousel> */}

                                            {/* <Carousel
                                                    responsive={responsive}
                                                    autoPlay={false}
                                                    swipeable={true}
                                                    draggable={true}
                                                    showDots={false}
                                                    infinite={true}
                                                    partialVisible={false}
                                                    dotListClass="custom-dot-list-style"
                                                    focusOnSelect={true}

                                                >
                                                    {partyInfo?.galleryImage?.map((image) => {
                                                        return (
                                                            <div

                                                                className="flex flex-col items-center mt-2 gap-3 "
                                                            >



                                                                <img className="rounded-xs " src={image} alt="" />



                                                            </div>
                                                        );
                                                    })}
                                                </Carousel> */}
                                            {/* </div> */}






                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* Footer */}
                    <Footer />
                </div>



            </div>
            {/* /Main Wrapper */}

        </>
    )
}

export default PartyInfo
